/**
 *
 * @param {Array} sourceTypes Array of either urls or storyblok images, the first one will be the one picked up
 */
function getImageSrc(sourceTypes) {
  let src = null

  for (const imgSrc of sourceTypes) {
    if (imgSrc && imgSrc?.filename) {
      src = imgSrc?.filename
      break
    }
    if (typeof imgSrc === 'string' && imgSrc) {
      src = imgSrc
      break
    }
  }

  return src
}

export { getImageSrc }
